import React from 'react';
import GenerateField from 'components/GenerateField';
import PropTypes from 'prop-types';
import { TAXREGISTRATION } from 'constants/companies';
import ReadOnlyRadioGroup from 'components/ReadOnlyRadioGroup';

const CGAInfo = ({ taxRegistration }) => {
  const fiedls = [
    {
      component: ReadOnlyRadioGroup,
      componentProps: {
        name: 'cga',
        options: TAXREGISTRATION.cga,
        value: taxRegistration.cga,
      },
    },
  ];

  return (
    <GenerateField
      name={'cga'}
      configs={fiedls}
      readOnly
      label="company.cga_info.title"
    />
  );
};

CGAInfo.propTypes = {
  taxRegistration: PropTypes.object,
};
export default CGAInfo;
